import { IntlFormatters } from 'react-intl';

/**
 * Returns the disclaimer message for native payments (Apple and Google Pay) when either are disabled.
 * However, we do use a test flag to be able to see native payment items in web in certain situations.
 * @param {boolean | undefined} allowApplePay If boolean value, this means the LD flag or Test LD flag is in use.
 * @param {boolean | undefined} allowGooglePay If boolean value, this means the LD flag or Test LD flag is in use.
 * @returns {string | undefined} a disclaimer message if LD flags are in use, otherwise it is undefined.
 */
export const getNativePaymentDisclaimer = (
  allowApplePay: boolean | undefined,
  allowGooglePay: boolean | undefined,
  formatMessage: IntlFormatters['formatMessage']
): string | undefined => {
  const shouldEvaluateFlags =
    typeof allowApplePay === 'boolean' && typeof allowGooglePay === 'boolean';

  // If web is not using the test LD flags related to native payments, do not bother evaluating.
  if (!shouldEvaluateFlags) {
    return undefined;
  }

  let nativePaymentDisclaimer;
  if (!allowApplePay && !allowGooglePay) {
    nativePaymentDisclaimer = formatMessage({ id: 'nativePaymentNotAvailable' });
  } else if (allowApplePay && !allowGooglePay) {
    nativePaymentDisclaimer = formatMessage({ id: 'googlePayPaymentNotAvailable' });
  } else if (!allowApplePay && allowGooglePay) {
    nativePaymentDisclaimer = formatMessage({ id: 'applePayPaymentNotAvailable' });
  }
  return nativePaymentDisclaimer;
};
